import React, { useState } from "react";
import {
  Collapse,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

import { StyledPinnedColumn, StyledTableCell } from "./styles";
import RolePermissionsTableSubRow from "./RolePermissionsTableSubRow";
import { HubIcon } from "../../components";

const RolePermissionsTableRow = ({ group = {}, roles = [] }) => {
  const [open, setOpen] = useState(true);

  const sx = open
    ? { ":hover": { backgroundColor: "transparent !important" } }
    : { border: "none" };

  return (
    <>
      <TableRow
        key={group?.id}
        onClick={() => setOpen((prev) => !prev)}
        sx={{ backgroundColor: "hubColors.mainFocusLightest" }}
      >
        <StyledPinnedColumn>
          <Stack direction="row" gap="5px" alignItems="center">
            <HubIcon icon={open ? "ChevronUp" : "ChevronDown"} size="12px" />
            <Typography variant="boldCaptionL" sx={{ fontSize: 12 }}>
              {group?.label}
            </Typography>
          </Stack>
        </StyledPinnedColumn>
        {roles?.map(() => (
          <StyledTableCell />
        ))}
      </TableRow>
      <TableRow sx={sx}>
        <TableCell
          colSpan={roles?.length + 1}
          sx={{ padding: "0px !important" }}
        >
          <Collapse in={open}>
            <Table>
              <TableBody>
                {group?.permissions?.map((p) => (
                  <RolePermissionsTableSubRow
                    key={p.id}
                    permission={p}
                    roles={roles}
                  />
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RolePermissionsTableRow;
